// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroller[data-v-a4da9bba]{height:calc(100vh - 165px);padding:0 20px;margin:0 -20px;overflow:auto}.spacer[data-v-a4da9bba]{height:50px}.bold[data-v-a4da9bba]{font-family:SFProDisplay-Medium,sans-serif;margin:0}.header[data-v-a4da9bba]{font-size:17px;line-height:22px}.mt-20[data-v-a4da9bba]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
